


























import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import VTimePicker, { TIME_FORMAT } from './VTimePicker.vue';
import ClickOutside from '../directives/ClickOutside';

export interface SlotObject {
  from: string;
  to: string;
}

@Component({
  components: {
    VTimePicker
  },
  directives: {
    ClickOutside
  }
})
export default class TimeSlotPicker extends Vue {
  @Prop({ required: true }) readonly value!: Array<SlotObject>;
  @Prop({ default: 'left' }) readonly dropdownAlign!: string;

  from = '';
  to = '';

  visible = false;

  slots: Array<SlotObject> = [];

  @Watch('from')
  onFromChange(value: string) {
    const from = this.$moment(value, TIME_FORMAT);
    const to = this.$moment(this.to, TIME_FORMAT);

    if (from.isAfter(to) || !this.to) {
      this.to = from.add(1, 'hour').format(TIME_FORMAT);
    }
  }

  get label(): string {
    if (this.slots.length === 0) {
      return 'Nessuna';
    }

    let label = this.slots[0].from + ' - ' + this.slots[0].to;

    if (this.slots.length > 1) {
      label = label + ' e altre ' + (this.slots.length - 1);
    }

    return label;
  }

  created() {
    this.slots = this.value;
    this.initializeTime();
  }

  initializeTime() {
    if (this.slots.length) {
      const slot = this.slots[this.slots.length - 1];
      this.from = slot.to;
      this.to = this.$moment(this.to, TIME_FORMAT).add(1, 'hour').format(TIME_FORMAT);
    } else {
      this.from = '00:00';
      this.to = '01:00';
    }
  }

  toggleDropdown() {
    this.visible = !this.visible;
  }

  closeDropdown() {
    if (this.visible) {
      this.visible = false;
    }
  }

  isAddDisabled() {
    if ((this.from === this.to) || !this.from || !this.to) {
      return true;
    }

    return false;
  }

  createSlot() {
    this.slots.push({
      from: this.from,
      to: this.to
    });

    this.$emit('input', this.slots);
    this.initializeTime();
  }

  deleteSlot(index: number) {
    this.slots.splice(index, 1);
    this.$emit('input', this.slots);
  }
}
